import React from "react";
import { AmcCard } from "../../AmcList/amc";
import { Link } from "gatsby";
import { sendToUrl } from "../../../utilities";

const TopAmc = ({ topAmcData: { top_amcs } }) => (
  <div className="topAmcSection">
    <h3 className="heading-3-bold" style={{ marginBottom: "16px" }}>Top Amc</h3>
    <div className="flex wrap space-between w-100 topAmcWrapper">
      {top_amcs.map((amc, id) => (
        <AmcCard amc={amc} key={id} />
      ))}
    </div>
    <Link
      to={sendToUrl(`/mutual-funds/amc/`)}
      className="flex pointer para-2-bold viewAll"
    >
      View All Mutual Funds AMC
    </Link>
    <style jsx>{`
    .topAmcSection{
      width: 77vw;
      margin: auto;
      margin-bottom: 120px;
      max-width: 1080px;
      padding: 0 24px;
    }
    .topAmcWrapper{
      margin:20px auto;
    }
    .viewAll{
      color:#4dc3b6;
      justify-content:flex-end;
      text-decoration:none;
      margin-top:16px;
    }
    @media (max-width: 768px){
      .topAmcSection {
        padding: 0 12px;
        margin-bottom: 48px;
      }
      .topAmcWrapper{
        width:100%;
      }
    }    
    @media (max-width: 600px) {
      .topAmcSection {
        width: 90vw;
      }
      .topAmcWrapper {
        flex-direction: column;
      }
    }
    `}</style>
  </div>
);

export default TopAmc;
